import { Injectable } from '@angular/core';
import { Patient } from '@api/patient';
import Helpers from '../helpers';

@Injectable({ providedIn: 'root' })

export class FeaturesCache {
  public patientSnapshot: Patient;
  public medicalConsultation: Consultation;
  public lastWeight: number;
  public lastHeight: number;

  public setLastWeightHeight(weight: number, height: number): void {
    this.lastWeight = weight;
    this.lastHeight = height;
  }

  lastEvaluationDate(): string {
    if (!this.patientSnapshot || !this.patientSnapshot.lastEvaluationDate)
      return "";
    else
      return Helpers.getDateString(this.patientSnapshot.lastEvaluationDate);
  }

  urlMail(): string {
    const email = this.patientSnapshot?.email || '';
    const subject = encodeURIComponent('Link de pago - Turno');
    const body = encodeURIComponent('');
    return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&su=${subject}&body=${body}`;
  }

  urlWpp(): string {
    let tel = this.patientSnapshot?.telephones[0];
    if (tel)
      return "https://api.whatsapp.com/send/?phone=" + tel.areaCode + 9 + tel.number + "&text&app_absent=0";
    return "";
  }

  telFullNumber(): string {
    let tel = this.patientSnapshot?.telephones[0];
    if (tel)
      return `${tel.areaCode}-${tel.number}`;
    return "";
  }

  telAreaCode(): number {
    let tel = this.patientSnapshot?.telephones[0];
    if (tel)
      return tel.areaCode;
  }

  telNumber(): number {
    let tel = this.patientSnapshot?.telephones[0];
    if (tel)
      return tel.number;
  }
}

interface Consultation {
  creationDate: string;
  evaluationId: number;
  id: number;
  observation: string;
  patientId: number;
  profesionalId: number;
}


